
import { PLACEHOLDER_DATA_URI } from '@/assets/placeholder'

export default {
  name: 'AppImage',
  props: {
    // 原始 URL，组件内部经 $img 规范化；空值回退到占位
    src: { type: String, default: '' },
    // 直通 van-image 的 fit：cover/contain/fill/none/scale-down/widthFix
    fit: { type: String, default: 'cover' },
    // CSS aspect-ratio 值，如 '1/1' '85/100' '16/9' '6/1'；空串=填满父盒
    ratio: { type: String, default: '' },
    // 固定 px 正方形，如 '80px'；优先级高于 ratio
    size: { type: String, default: '' },
    // 是否懒加载
    lazy: { type: Boolean, default: true },
    // absolute 撑满 position:relative 父容器；用于 padding-bottom 比例容器
    // （CSS column 瀑布流等场景下 aspect-ratio 高度不生效，需用 padding-bottom + absolute fill）
    fill: { type: Boolean, default: false },
    alt: { type: String, default: '' },
    // COS 缩略档位（thumb/medium/large/original）；默认 medium，大图位显式传 large，全屏查看器传 original
    imgSize: { type: String, default: 'medium' }
  },
  data () {
    return {
      placeholder: PLACEHOLDER_DATA_URI,
      isError: false
    }
  },
  computed: {
    resolvedSrc () {
      // 复用全局 $img 做 URL 规范化；imgSize 直通 COS 缩略档位；返回 null（空/非法）时回退占位
      return this.$img(this.src, this.imgSize) || PLACEHOLDER_DATA_URI
    },
    isWidthFix () {
      return this.fit === 'widthFix'
    },
    // 尺寸模式统一用 inline style，避免被外部 scoped class 的 width/height 覆盖
    boxStyle () {
      if (this.fill) return { position: 'absolute', top: '0', left: '0', width: '100%', height: '100%' }
      if (this.isWidthFix) return { width: '100%' }
      if (this.size) return { width: this.size, height: this.size }
      if (this.ratio) return { width: '100%', aspectRatio: this.ratio }
      return { width: '100%', height: '100%' }
    }
  },
  methods: {
    onError (e) {
      this.isError = true
      this.$emit('error', e)
    }
  }
}
